import { Reveal } from "@/components/Reveal";

const ROWS = [
  ["XS", "40", "27.5", "20.5"],
  ["S", "42", "28", "21"],
  ["M", "44", "28.5", "21.5"],
  ["L", "46", "29", "22"],
  ["XL", "48", "29.5", "22.5"],
  ["XXL", "50", "30", "23"],
];

export default function SizeGuide({ kicker = "07 — SIZE GUIDE" }) {
  return (
    <section data-testid="size-guide-section" className="bg-paper text-ink py-24 sm:py-32">
      <div className="mx-auto max-w-4xl px-5 sm:px-10">
        <Reveal>
          <p className="font-sans text-xs font-semibold tracking-[0.35em] text-black/50 mb-4">{kicker}</p>
          <h2 className="font-display text-[clamp(2.4rem,6vw,5rem)] leading-[0.9]">FIND YOUR FIT.</h2>
          <p className="font-sans font-semibold text-sm tracking-[0.3em] text-black/60 mt-3">OVERSIZED T-SHIRT</p>
        </Reveal>

        <Reveal delay={0.15} className="mt-12">
          <div className="overflow-x-auto border-2 border-black" data-testid="size-table">
            <table className="w-full font-sans text-sm sm:text-base">
              <thead>
                <tr className="bg-black text-paper">
                  {["SIZE", "CHEST", "LENGTH", "SHOULDER"].map((h) => (
                    <th key={h} className="font-bold tracking-[0.25em] text-left px-5 py-4">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ROWS.map((r) => (
                  <tr key={r[0]} className="border-t border-black/15 hover:bg-acid/40 transition-colors">
                    <td className="font-bold px-5 py-4">{r[0]}</td>
                    <td className="px-5 py-4">{r[1]}</td>
                    <td className="px-5 py-4">{r[2]}</td>
                    <td className="px-5 py-4">{r[3]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex flex-wrap justify-between gap-3 mt-5">
            <p className="font-sans text-black/50 text-xs tracking-[0.2em]">MEASUREMENTS ARE IN INCHES.</p>
            <p className="font-hand text-2xl text-black/70 -rotate-1">this is an oversized fit.</p>
          </div>
        </Reveal>

        <Reveal delay={0.2} className="mt-10">
          <div data-testid="measure-tips">
            <p className="font-sans font-bold text-sm tracking-[0.3em] mb-4">HOW TO MEASURE YOURSELF</p>
            <div className="grid sm:grid-cols-3 border-2 border-black divide-y-2 sm:divide-y-0 sm:divide-x-2 divide-black">
              {[
                ["CHEST", "Wrap the tape around the fullest part of your chest, under the armpits. Keep it level."],
                ["LENGTH", "From the highest point of your shoulder straight down to where you want the hem."],
                ["SHOULDER", "Seam to seam across your back, bone to bone. A tee that fits you well is the best guide."],
              ].map(([k, v], i) => (
                <div key={k} className="px-5 py-5" data-testid={`measure-tip-${k.toLowerCase()}`}>
                  <p className="font-display text-pink text-lg mb-2">0{i + 1} — {k}</p>
                  <p className="font-sans text-sm text-black/70 leading-relaxed">{v}</p>
                </div>
              ))}
            </div>
            <p className="font-hand text-2xl text-black/60 mt-5 rotate-1" data-testid="measure-tip-note">
              between sizes? go down for neat, up for drama.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
